import React, { useEffect, useState } from "react";
import { CONSENT_EVENT, getConsent, initConsent, setConsent } from "../lib/tracking";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    initConsent();
    if (!getConsent()) setOpen(true);
    const show = () => setOpen(true);
    window.addEventListener(CONSENT_EVENT, show);
    return () => window.removeEventListener(CONSENT_EVENT, show);
  }, []);

  if (!open) return null;

  const choose = (v) => {
    setConsent(v);
    setOpen(false);
  };

  const current = getConsent();

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Preferenze cookie"
      data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-[560px] rounded-2xl p-5 sm:bottom-24"
      style={{ background: "rgba(10,12,20,0.96)", border: "1px solid rgba(255,255,255,0.12)", backdropFilter: "blur(12px)", boxShadow: "0 20px 60px rgba(0,0,0,0.6)", fontFamily: "'Instrument Sans', sans-serif" }}
    >
      <div className="flex justify-end">
        <button type="button" data-testid="cookie-reject" onClick={() => choose("denied")} className="-mr-1 -mt-1 px-1 py-0.5 underline-offset-4 hover:underline" style={{ border: 0, background: "none", color: "#8A8792", fontWeight: 500, fontSize: "0.8rem" }}>
          Continua senza accettare
        </button>
      </div>
      <p className="mt-1" style={{ color: "#fff", fontWeight: 700, fontSize: "0.98rem" }}>Cookie e misurazione</p>
      <p className="mt-2" style={{ color: "#B4B1BA", fontSize: "0.86rem", lineHeight: 1.5 }}>
        Usiamo cookie di Google Ads solo con il tuo consenso, per misurare l'efficacia delle nostre campagne. Anche senza consenso, Google Ads riceve segnali anonimi senza cookie per misurare l'efficacia delle campagne. Puoi cambiare idea in qualsiasi momento da "Preferenze cookie" in fondo alla pagina.
      </p>
      {current && (
        <p data-testid="cookie-current-choice" className="mt-2" style={{ color: "#7C7A83", fontSize: "0.8rem" }}>
          Scelta attuale: {current === "granted" ? "accettati" : "rifiutati"}
        </p>
      )}
      <div className="mt-4 flex sm:justify-end">
        <button type="button" data-testid="cookie-accept" onClick={() => choose("granted")} className="w-full rounded-full px-5 py-2.5 sm:w-auto sm:px-8" style={{ background: "#2E6BFF", color: "#fff", fontWeight: 700, fontSize: "0.88rem", border: "1px solid #2E6BFF" }}>
          Ok
        </button>
      </div>
    </div>
  );
}
